<template>
    <ValidationObserver ref="changeOfProgramForm">
        <b-container class="mt-5">
            <b-card class="p-5">
                <b-row class="text-center mb-4">
                    <b-col cols="12" class="d-flex align-items-center justify-content-between">
                        <img src="../../../assets/img/BAU_Logo.png" height="75" alt="BAU Logo" />
                        <h5 class="mb-0 font-weight-bold">Change of Program Request Form</h5>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" md="4">
                        <ValidationProvider name="application_number" rules="required" v-slot="{ errors }">
                            <b-form-group label="Application Number">
                                <b-form-input v-model="form.application_number" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col cols="12" md="4">
                        <ValidationProvider name="student_id" rules="required" v-slot="{ errors }">
                            <b-form-group label="Student ID">
                                <b-form-input v-model="form.student_id" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col cols="12" md="4">
                        <ValidationProvider name="s_id" rules="required" v-slot="{ errors }">
                            <b-form-group label="SEVIS ID">
                                <b-form-input v-model="form.s_id" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" md="4">
                        <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                            <b-form-group label="First Name">
                                <b-form-input v-model="form.name" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col cols="12" md="4">
                        <ValidationProvider name="surname" rules="required" v-slot="{ errors }">
                            <b-form-group label="Last Name">
                                <b-form-input v-model="form.surname" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col cols="12" md="4">
                        <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                            <b-form-group label="Email Address">
                                <b-form-input type="email" v-model="form.email" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" md="4">
                        <ValidationProvider name="phone" rules="required" v-slot="{ errors }">
                            <b-form-group label="Phone Number">
                                <b-form-input v-model="form.phone" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col cols="12" md="4">
                        <ValidationProvider name="address" rules="required" v-slot="{ errors }">
                            <b-form-group label="Mailing Address">
                                <b-form-input v-model="form.address" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col cols="12" md="4">
                        <ValidationProvider name="start_date" rules="required" v-slot="{ errors }">
                            <b-form-group label="Start Date (Semester/Year)">
                                <select-date v-model="form.start_date" :validation-error="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>

                <h5 class="mt-4">Program Change Request</h5>
                <b-row>
                    <b-col cols="12">
                        <ValidationProvider name="level_of_study" rules="required" v-slot="{ errors }">
                            <b-form-group label="Please indicate your current level of study:">
                                <b-form-checkbox-group v-model="form.level_of_study" name="level_of_study" class="d-flex">
                                    <b-form-checkbox value="ESL" class="mr-3">ESL Program</b-form-checkbox>
                                    <b-form-checkbox value="Undergraduate" class="mr-3">Undergraduate</b-form-checkbox>
                                    <b-form-checkbox value="Graduate" class="mr-3">Graduate</b-form-checkbox>
                                </b-form-checkbox-group>
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="current_program" rules="required" v-slot="{ errors }">
                            <b-form-group label="Current Program">
                                <b-form-select v-model="form.current_program" :options="programOptions" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col cols="12" md="6">
                        <ValidationProvider name="new_program" rules="required" v-slot="{ errors }">
                            <b-form-group label="New Program">
                                <b-form-select v-model="form.new_program" :options="programOptions" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <ValidationProvider name="explanation" rules="required" v-slot="{ errors }">
                            <b-form-group label="Please explain further, as thoroughly as possible, the reasons for this program change">
                                <b-form-textarea rows="4" v-model="form.explanation" :class="errors[0] ? 'is-invalid' : ''" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="student_signature" rules="required" v-slot="{ errors }">
                            <b-form-group label="Student Signature">
                                <b-form-input v-model="form.student_signature" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>

                    <b-col cols="12" md="6">
                        <ValidationProvider name="signature_date" rules="required" v-slot="{ errors }">
                            <b-form-group label="Date">
                                <select-date v-model="form.signature_date" :validation-error="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <h5 class="mt-4">Academic Student Acknowledgments</h5>
                <b-row>
                    <b-col cols="12">
                        <b-form-checkbox-group v-model="form.acknowledgments" stacked>
                            <b-form-checkbox value="advisor_meeting">I met with my Academic Advisor from my current program.</b-form-checkbox>
                            <b-form-checkbox value="degree_review">I have reviewed my degree evaluation and requirements of the new program.</b-form-checkbox>
                            <b-form-checkbox value="cgpa_recalculated">I recognize that my CGPA and program length will be recalculated.</b-form-checkbox>
                            <b-form-checkbox value="effect_next_semester">I understand that my change of program request will take effect in the following semester.</b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group label="Academic Advisor Signature">
                            <b-form-input v-model="form.academic_signature" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group label="Date">
                            <select-date v-model="form.academic_date" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <h5 class="mt-4">FOR STUDENTS SWITCHING THE PROGRAM TO MENTORA COLLEGE ESL PROGRAM</h5>
                <p>Students who withdraw from BAU degree programs to pursue studies at Mentora College Intensive ESL program will be required to pay 3
                    months of session fees of Mentora College (tuition and mandatory fee) upon changing the program.</p>
                <b-row>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="finance_approval" rules="required" v-slot="{ errors }">
                            <b-form-group label="Finance Approval">
                                <b-form-input v-model="form.finance_approval" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="finance_approval_date" rules="required" v-slot="{ errors }">
                            <b-form-group label="Date">
                                <select-date v-model="form.finance_approval_date" :validation-error="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="registrar" rules="required" v-slot="{ errors }">
                            <b-form-group label="Director of Admissions (BAU) / Registrar (BAU)">
                                <b-form-input v-model="form.registrar" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="registrar_date" rules="required" v-slot="{ errors }">
                            <b-form-group label="Date">
                                <select-date v-model="form.registrar_date" :validation-error="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <h5 class="mt-4">MENTORA ESL APPROVAL</h5>
                <b-row>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="officer_approval" rules="required" v-slot="{ errors }">
                            <b-form-group label="Director Mentora ESL Program /Admissions Officer Approval">
                                <b-form-input v-model="form.officer_approval" />
                                <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="officer_approval_date" rules="required" v-slot="{ errors }">
                            <b-form-group label="Date">
                                <select-date v-model="form.officer_approval_date" :validation-error="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <b-button variant="primary" class="mt-4" @click="sendForm">Send Form</b-button>
            </b-card>
        </b-container>
    </ValidationObserver>
</template>

<script>

export default {
    components: {
    },
    data() {
        return {
            form: {
                application_number: null,
                student_id: null,
                name: null,
                surname: null,
                email: null,
                phone: null,
                address: null,
                level_of_study: null,
                current_program: null,
                new_program: null,
                explanation: null,
                student_signature: null,
                signature_date: null,
                acknowledgments: null,
                academic_signature: null,
                academic_date: null,
                finance_approval: null,
                finance_approval_date: null,
                registrar: null,
                registrar_date: null,
                officer_approval: null,
                officer_approval_date: null,
            },
        };
    },
    metaInfo() {
        return {
            title: "PROGRAM CHANGE REQUEST",
        };
    },
    watch: {
        form: {
            handler(val) {
                if (val.absentSemester === 1) {
                    this.form.returnSemester = this.$t('spring_2025');
                } else if (val.absentSemester === 2) {
                    this.form.returnSemester = this.$t('summer_2025');
                }
            },
            deep: true,
        },
    },
    methods: {
        sendForm() {
        },
    },
};
</script>
